import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=2ce72d14&scoped=true&lang=pug"
import script from "./ReservationDetail.vue?vue&type=script&lang=ts"
export * from "./ReservationDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=2ce72d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce72d14",
  null
  
)

export default component.exports